import React, { useState } from "react";
import { useTranslation } from "../../i18n";
import "./NewsletterSignup.css";

const BACKEND_URL = "https://theqahubweb-production.up.railway.app"; 

const NewsletterSignup = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email) {
            setMessage(t("newsletter.invalid"));
            return;
        }
        
        try {
            const response = await fetch(BACKEND_URL + "/api/subscribe", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            if (response.ok) {
                setMessage(t("newsletter.success"));
                setEmail("");
            } else {
                setMessage(`Error: ${data.message}`);
            }
        } catch (error) {
            setMessage(t("newsletter.error"));
        }
    };

    return (
        <div className="newsletter-section">
            <h2 className="newsletter-title">{t("newsletter.title")}</h2>
            <p className="newsletter-intro">
                {t("newsletter.intro")}
            </p>
            <div className="newsletter-container">
                <h2>{t("newsletter.formTitle")}</h2>
                <p>{t("newsletter.formText")}</p>
                
                <form onSubmit={handleSubmit} className="newsletter-form">
                    <input
                        type="email"
                        placeholder={t("newsletter.placeholder")}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit">{t("newsletter.button")}</button>
                </form>

                {message && <p className="newsletter-message">{message}</p>}
            </div>
        </div>
    );
};

export default NewsletterSignup;
